module.exports = __webpack_public_path__ + "media/images/share-ce2e56b7.png";